var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21949",
    "data-name": "Group 21949",
    transform: "translate(-1104 -1085)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1465",
    "data-name": "Ellipse 1465",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1104 1085)",
    fill: "#f46d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-thumbs-up",
    "data-name": "Icon feather-thumbs-up",
    d: "M11.4,7.9V5.1A2.1,2.1,0,0,0,9.3,3L6.5,9.3V17h7.9a1.4,1.4,0,0,0,1.4-1.19l.966-6.3a1.4,1.4,0,0,0-1.4-1.61ZM6.5,17H4.4A1.4,1.4,0,0,1,3,15.6V10.7A1.4,1.4,0,0,1,4.4,9.3H6.5",
    transform: "translate(1111.5 1091.227)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeEmoji);
export default __webpack_public_path__ + "static/media/like_emoji.fc15bfdbfa33f5e9c0ad212ea42cec4f.svg";
export { ForwardRef as ReactComponent };